import { Component, OnInit,Input, Output ,EventEmitter} from '@angular/core';
import {FormBuilder, FormGroup, Validators, NgForm, FormControl} from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import * as $ from 'jquery';
import * as bcrypt from 'bcryptjs';

import { AppserviceService } from 'src/app/appservice.service';
import { timeout } from 'rxjs/operators';


@Component({
  selector: 'app-userdialog',
  templateUrl: './userdialog.component.html',
  styleUrls: ['./userdialog.component.sass']
})
export class UserdialogComponent implements OnInit {
  username:string;
  password:string;
  loginform:any;
  resetform:any;
  updateform:any;
  errorMsg:string;
  errorbol:boolean = false;
  _adminBool:boolean = false;
  showLogin:boolean = true;
  forgotpage:boolean = false;
  updatepage:boolean = false;
  reseterrorbol:boolean = false;

  emailid = '';
  loginHeader = '';
  emailerror = '';

  @Input()showClose;
  //@Output() userDetails = {};
  

  loginModel = {
    'user':'',
    'pass':''
  };

  resetModel = {
    'email':''
  };

  updateModel = {
    'newpass':'',
    'confirmpass':'',
    'resetcode':''
  };

  constructor(private modalService:NgbModal, private activeModal: NgbActiveModal, private Appservice:AppserviceService, private router:Router, private spinner:NgxSpinnerService) {}
  @Output() public userdetails = new EventEmitter();
  @Output() public adminubool: EventEmitter<Boolean> = new EventEmitter();
  
  storeUser(){
    var logindetails = {
      'userid': this.loginform.value.username,
      'key':this.loginform.value.password,
      'hashvalue': ''
    };
    this.spinner.show();
    let subscription = this.Appservice.getSalt(logindetails).subscribe(
      (saltData) => {
        console.log(saltData['data']);
        logindetails['hashvalue'] = saltData['data'][0];
        this.getLogin(logindetails);
      },
      (err) => {
        console.log('Err : ', err);
        this.errorbol = true;
        this.errorMsg = err.error['message'];
        this.spinner.hide();
      }
    );

    setTimeout(() => subscription.unsubscribe(), 60000); 
  }
  sendUserDetails(userBool){
    //console.log(userBool);
    this.userdetails.emit(localStorage.getItem('username'));
    this.adminubool.emit(userBool);
  }

  getLogin(logindetails){
    var that = this;
    var appService = this.Appservice;
    bcrypt.hash(logindetails['key'], logindetails['hashvalue']).then(function(hash) {
      var input = {
        'details': hash,
        'userid':logindetails['userid']
      }
      //logindetails['hashvalue'] = saltData['data'][0];
      var _ajax = $.post(that.Appservice.getBaseUrl() +'signin', input, results => {
        localStorage.setItem('username', results['branch']['user']);
        localStorage.setItem('admin',results['branch']['admin']);
        localStorage.setItem('authorization', _ajax.getResponseHeader('Authorization'));
        //that.userDetails = results['branch']['user'];
        //console.log(that.userDetails);
        that._adminBool = results['branch']['admin'] === 1?true:false;
        appService.setAdminBool(that._adminBool);
        appService.setUser(results['branch']['user']);
        that.sendUserDetails(that._adminBool);
        that.router.navigate(['/home']);
        that.activeModal.close();
        
        appService.fetchFeEngineers().subscribe((feData) => {
          /* feData['data'] = Object.assign([], feData['data']).filter(item => {
            if(item.name !== localStorage.getItem('username')){
              return item;
            }
          }) */
          appService.setEngData(feData['data']);
        });

        appService.rslStores('').subscribe((rslData) => {
          appService.setRslData(rslData['data']);
        });
        that.spinner.hide();
      });
      setTimeout(function(){
        if(_ajax.status === 401){
          //console.log('In Error', _ajax, _ajax.responseJSON.message);
          that.errorbol = true;
          that.errorMsg = _ajax.responseJSON.message;
          that.spinner.hide();
        }
      },1000);
      //that.router.navigate(['/home']);
    });
  }

  showLoginDiv(){
    this.loginHeader = "LOGIN";
    this.forgotpage = false;
    this.updatepage = false;
    this.showLogin = true;
  }

  forgotPassword(){
    this.loginHeader = "RESET";
    this.forgotpage = true;
    this.updatepage = false;
    this.showLogin = false;
  }

  showUpdate(){
    this.loginHeader = "UPDATE";
    this.forgotpage = false;
    this.updatepage = true;
    this.showLogin = false;
  }

  resetPassword(){
    var email = this.emailid;
    if(email != ''){
      this.spinner.show();
      this.Appservice.resetPassword(email).subscribe(
        (data) => {
          this.showUpdate();
          console.log('Email sent to your mail!');
          this.spinner.hide();
        },
        (err) => {
          console.log(err);
          this.reseterrorbol = true;
          $('#errordiv').show();
          this.spinner.hide();
          this.emailerror = err.error.message;
        }
      );
    }else{
      $('#errordiv').show();
      this.emailerror = "Please enter email ID.";
    }
  }

  updatePassword(){
    var input = {
      key:this.updateform.value.newpassword,
      resetcode:this.updateform.value.resetcode
  };
    if(input.key != ''){
      this.spinner.show();
      this.Appservice.updatePassword(input).subscribe(
        (data) => {
          this.showLoginDiv();
          console.log('Email sent to your mail!');
          this.spinner.hide();
        },
        (err) => {
          console.log(err);
          this.reseterrorbol = true;
          $('#errorupdatediv').innerHTML(err.message).show();
          this.spinner.hide();
        }
      );
    }else{
      $('#errorupdatediv').show();
    }
  }

  resetLoginFields(event){
    console.log(event);
    this.errorbol = false;
    //$('#errorupdatediv').innerHTML().show();
  }

  confirmpwverify(event){
    if(this.updateModel.newpass != event.target.value){
      $('#errorupdatediv').innerHTML('Passwords does not match!').show();
    }else{
      $('#errorupdatediv').hide();
    }
  }

  ngOnInit() {
    this.loginHeader = "LOGIN";
    this.loginform = new FormGroup({
      'username':new FormControl(this.loginModel.user,[
        Validators.required
      ]),
      'password':new FormControl(this.loginModel.pass,[
        Validators.required
      ])
    });

    this.resetform = new FormGroup({
      'email':new FormControl(this.resetModel.email,[
        Validators.required
      ])
    });

    this.updateform = new FormGroup({
      'newpassword':new FormControl(this.updateModel.newpass,[
        Validators.required
      ]),
      'confirmpassword':new FormControl(this.updateModel.confirmpass,[
        Validators.required
      ]),
      'resetcode':new FormControl(this.updateModel.resetcode,[
        Validators.required
      ])
    });
  }
}
